import i18n from '@hw-core/libs/i18n'

export const STATE_OPTIONS = [
  'ahvenanmaa',
  'etelä-karjala',
  'etelä-pohjanmaa',
  'etelä-savo',
  'kainuu',
  'kanta-häme',
  'keski-pohjanmaa',
  'keski-suomi',
  'kymenlaakso',
  'lappi',
  'pirkanmaa',
  'pohjanmaa',
  'pohjois-karjala',
  'pohjois-pohjanmaa',
  'pohjois-savo',
  'päijät-häme',
  'satakunta',
  'varsinais-suomi',
  'uusimaa',
]

export const OIWA_OPTIONS = [
  {
    label: 'Kaikki',
    value: 'all',
  },
  {
    label: 'Oiwa työnhakijat',
    value: 'oiwa_only',
  }
]

export const STEP_OPTIONS = [
  {
    label: 'No answer',
    value: 'no_answer',
  },
  {
    label: 'Valvira confirmed',
    value: 'confirm_valvira',
  },
  {
    label: 'Interview sent',
    value: 'send_interview',
  },
  {
    label: 'Interview scheduled',
    value: 'schedule',
  },
  {
    label: 'Interview submitted',
    value: 'submit_interview',
  },
  {
    label: 'Interview listened',
    value: 'confirm_interview',
  },
  {
    label: 'Documents requested',
    value: 'request_documents',
  },
  {
    label: 'Documents confirmed',
    value: 'confirmed_documents',
  },
  {
    label: 'Waiting for contract',
    value: 'waiting_for_contract',
  },
  {
    label: 'Contract pending',
    value: 'contract_pending',
  },
]

export const PLAN_OPTIONS = [
  { label: 'Suoritettu', value: 'suoritettu' },
  { label: 'Ei suoritettu', value: 'ei' },
]

export const STATUS_OPTIONS = [
  { label: 'Pending', value: 'pending' },
  { label: 'Accepted', value: 'accepted' },
  { label: 'Rejected', value: 'rejected' },
]

export const SEEKING_OPTIONS = [
  { text: i18n.t('application.filters.seekingGig'), value: 'gig' },
  { text: i18n.t('application.filters.seekingLongTerm'), value: 'long-term' },
  { text: i18n.t('application.filters.seekingPeriodic'), value: 'periodic' },
]

export const SHIFT_REQUIREMENT_OPTIONS_OIWA = [
  
]

export const SHIFT_REQUIREMENTS_OPTIONS_FINLAND = [
  'love',
  'medieco',
  'proedu',
  'lop',
  'rok',
  'iv',
  'aku',
  'rtg',
  'abo',
  'kipu 1',
  'kipu 2',
  'psyk 1',
  'psyk 2',
  'ger 1',
  'ger 2',
  'lääkeluvat ei tarvita',
  'aikaisempi kokemus kohteessa',
  'luvaton',
  "ammattikortti",
  "hygieniapassi",
  'apotti',
  'rover osaaminen',
  'ajokortti',
  'oma auto',
  'rokotuslupa',
  'kotiavustaja',
  'akuutti',
  'ruotsinkieli',
  'rokotesuoja',
  'vain opiskelija',
  'ei opiskelija',
  'myös opiskelija',
  'lifecare piho',
  'lifecare koho',
]

export const AGE_OPTIONS = [
  { label: 'Kyllä', value: 'kyllä' },
]

export const SHIFT_REQUIREMENTS_OPTIONS_GERMANY = [
  'Führerschein',
  'Englisch',
  'PKW verfügbar',
]

export const RESIDENCY_OPTIONS = [
  { label: 'Suomi', value: 'finland' },
  { label: 'Deutschland', value: 'germany' }
]

export const SUBCONTRACTOR_OPTIONS = [
  { label: 'Kyllä', value: 'kyllä' },
]